import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaStar } from 'react-icons/fa';
import type { IconBaseProps, IconType } from 'react-icons';

const asIconComponent = (Icon: IconType, name: string) => {
  const Comp: React.FC<IconBaseProps> = (props) => {
    const element = Icon(props);
    return element as React.ReactElement;
  };
  Comp.displayName = name;
  return Comp;
};

const FeedbackStarIcon = asIconComponent(FaStar, 'FeedbackStarIcon');

type FeedbackItem = {
  quote: string;
  name: string;
  company: string;
  companyUrl?: string;
};

const AboutFeedback = () => {
  const { t } = useTranslation();
  const feedbackItems = t('about.feedback.items', {
    returnObjects: true,
  }) as FeedbackItem[];

  return (
    <section className="about-section about-feedback">
      <div className="about-section-heading about-section-heading-centered">
        <span>{t('about.feedback.label')}</span>
        <h2>{t('about.feedback.title')}</h2>
        <p>{t('about.feedback.subtitle')}</p>
      </div>

      <div className="about-feedback-grid">
        {feedbackItems.map((item) => (
          <article
            className="about-feedback-card"
            key={`${item.name}-${item.company}`}
          >
            <div className="about-feedback-stars" aria-hidden="true">
              {Array.from({ length: 5 }).map((_, index) => (
                <FeedbackStarIcon key={index} />
              ))}
            </div>
            <p>{item.quote}</p>
            <footer>
              <strong>{item.name}</strong>
              {item.companyUrl ? (
                <a
                  href={item.companyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.company}
                </a>
              ) : (
                <span>{item.company}</span>
              )}
            </footer>
          </article>
        ))}
      </div>
    </section>
  );
};

export default AboutFeedback;
